module.exports = __webpack_public_path__ + "img/1.812d8ad3.jpg";